import React from 'react';
import {CARD_DEFAULT} from "../../constants";
import {createEvent} from "./Events/CardClick";

const Card = (props) => {
    const {
        data        = CARD_DEFAULT,
        disabled    = false,
        overlay     = false,
        width       = null,
    } = props;

    const handleClick = (event) => {
        createEvent(event, data.id);
    }

    return (
        <div
            className={overlay ? "kanban-card overlay" : "kanban-card"}
            style={!!width ? {width: width+"px"} : {}}
        >
            <div className="details">
                <div className={"name"}>
                    {data.name}
                </div>
                <div className={"description"}>
                    {data.description}
                </div>
            </div>
            <div className="control">
                <div
                    className={"view-button"}
                    onClick={(event) => disabled || overlay ? {} :  handleClick(event)}
                >
                    <i className="fas fa-ellipsis-h" />
                </div>
            </div>
        </div>
    );
}

export default Card;
